var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"stage-tag",style:({ background: _vm.cfg.color + '1a', color: _vm.cfg.color })},[_vm._v(" "+_vm._s(_vm.cfg.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }